import React, { cloneElement, ReactElement, useCallback, useState } from 'react';
import { SwitchTransition } from 'react-transition-group';
import { useTranslation } from '../../utils/useTranslation';
import { Drawer, DrawerContent } from '../feedback/Drawer';
import { Button } from '../input/Button';
import { Flex } from '../layout/Flex';
import { TransitionSlideUp } from '../transition/TransitionSlideUp';
import { Typography } from '../typography/Typography';
import { PostStatus } from './constants';

interface PostStatusDrawerProps {
    title: string;
    handleClose: VoidFunction;
    descriptionSlot?: ReactElement;
    status?: PostStatus;
    onRemove?: VoidFunction;
}

export const PostStatusDrawer = (props: PostStatusDrawerProps) => {
    const { handleClose, onRemove, title, descriptionSlot, status } = props;
    const [step, setStep] = useState<'OPEN' | 'CLOSE'>('OPEN');
    const onClose = useCallback(() => {
        setStep('CLOSE');
        handleClose();
    }, [handleClose]);
    const t = useTranslation();

    return (
        <SwitchTransition>
            <TransitionSlideUp key={step}>
                <Drawer onClose={onClose}>
                    <DrawerContent p={2}>
                        <Typography variant="title3" weight="bold" pb={2}>
                            {title}
                        </Typography>
                        {descriptionSlot && cloneElement(descriptionSlot)}
                        <Flex width="100%" spacing={1} pt={2}>
                            {status === PostStatus.MODERATION && (
                                <Button color="primary" onClick={onClose} width="100%">
                                    {t('Понятно')}
                                </Button>
                            )}
                            {status === PostStatus.DECLINED && (
                                <Button onClick={onRemove} color="secondary" width="100%">
                                    {t('Удалить пост')}
                                </Button>
                            )}
                            {status === PostStatus.DECLINED && (
                                <Button onClick={onClose} color="primary" width="100%">
                                    {t('Закрыть')}
                                </Button>
                            )}
                        </Flex>
                    </DrawerContent>
                </Drawer>
            </TransitionSlideUp>
        </SwitchTransition>
    );
};
